import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, Table, Text, Tooltip } from "@mantine/core";
import { ArchiveOutlined, RestoreOutlined } from "@mui/icons-material";
import { IconButton, SvgIcon } from "@mui/material";
import { getRelativeTimeFromDate } from "../../utils/Date.utils";
import { createShortAddressString } from "../../utils/String.utils";
import { ContactInfo } from "../../shared/ContactInfo";
export const WebsiteLeadRow = ({ websiteLead, moveWebsiteLeadToPriorityEntry, archiveRestoreWebsiteLead, modalHandlers }) => {
    const caregiverName = `${websiteLead?.caregiver?.lastName}, ${websiteLead?.caregiver?.firstName}`;
    const patientName = `${websiteLead?.patient?.lastName}, ${websiteLead?.patient?.firstName}`;
    const therapyCategoryName = websiteLead?.therapyCategory?.name;
    const location = websiteLead?.patient?.postalCodeInfo
        ? createShortAddressString(websiteLead?.patient?.postalCodeInfo)
        : "-";
    const openPatientProfileDrawer = () => {
        modalHandlers?.patientProfileDrawerOpen(websiteLead?.patient?.patientId ?? "");
    };
    return (_jsxs(Table.Tr, { style: { cursor: "pointer" }, onClick: openPatientProfileDrawer, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, children: [_jsx(Table.Td, { style: { paddingLeft: "0.5rem" }, children: _jsx(Text, { variant: "body", size: "xs", truncate: "end", children: caregiverName }) }), _jsx(Table.Td, { children: _jsx(ContactInfo, { email: websiteLead?.caregiver?.email ?? "", phoneNumber: websiteLead?.caregiver?.phoneNumber ?? "" }) }), _jsx(Table.Td, { children: _jsx(Text, { variant: "body", size: "xs", truncate: "end", children: patientName }) }), _jsx(Table.Td, { children: therapyCategoryName && (_jsx(Badge, { size: "xs", color: "var(--mantine-color-secondary-5)", children: therapyCategoryName }, therapyCategoryName)) }), _jsx(Table.Td, { children: _jsx(Text, { variant: "meta", truncate: "end", children: location }) }), _jsx(Table.Td, { children: websiteLead?.createdAt
                    ? getRelativeTimeFromDate(websiteLead?.createdAt)
                    : "-" }), _jsx(Table.Td, { style: { width: "7rem" }, children: _jsxs("div", { style: {
                        display: "flex",
                        gap: "0.5rem",
                        alignItems: "center",
                        justifyContent: "flex-end"
                    }, children: [!websiteLead?.archivedAt && (_jsx(Button, { variant: "outline", style: { flexShrink: 0 }, styles: {
                                root: {
                                    color: "var(--mantine-color-secondary-5)",
                                    borderColor: "var(--mantine-color-secondary-5)"
                                }
                            }, onClick: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                moveWebsiteLeadToPriorityEntry(websiteLead?.websiteLeadId ?? "");
                            }, children: "Add to Pipeline" })), _jsx(Tooltip, { label: websiteLead?.archivedAt
                                ? "Restore Lead"
                                : "Archive Lead", position: "bottom-start", openDelay: 750, transitionProps: {
                                transition: "slide-up",
                                duration: 150
                            }, children: _jsx(IconButton, { style: {
                                    color: websiteLead?.archivedAt
                                        ? "var(--mantine-color-primary-9)"
                                        : "var(--mantine-color-red-5)"
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    archiveRestoreWebsiteLead(websiteLead?.websiteLeadId ?? "");
                                }, children: _jsx(SvgIcon, { component: websiteLead?.archivedAt
                                        ? RestoreOutlined
                                        : ArchiveOutlined, style: { fontSize: "1.2rem" } }) }) })] }) })] }));
};
